module.exports = __webpack_public_path__ + "img/no-survey-data.b0c699e0.svg";